import { render, staticRenderFns } from "./AccountsSearch.vue?vue&type=template&id=04a98c28&"
import script from "./AccountsSearch.vue?vue&type=script&lang=js&"
export * from "./AccountsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports